var map = {
	"./alipay.webp": "cf35",
	"./apple-pay.webp": "dcc34",
	"./card.webp": "8533",
	"./google-pay.webp": "6c25",
	"./mastercard.webp": "a11d",
	"./payme.webp": "80f7",
	"./paypal.webp": "2f49",
	"./visa.webp": "c4db",
	"./wechat.webp": "6c75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "881b";